export enum CalendarView {
  MONTH = 'month',
  WEEK = 'week',
  DAY = 'day',
}

export enum CalendarEventKey {
  MILESTONES = 'milestones',
  TASKS = 'tasks',
  SHOWINGS = 'showings',
  TOURS = 'tours',
  CLOSINGS = 'closings',
  PROJECT_KICKOFFS = 'projectKickoffs',
  EXPIRING_OFFERS = 'expiringOffers',
  EXPIRING_LISTINGS = 'expiringListings',
  EXPIRING_PROJECTS = 'expiringProjects',
}

export enum CalendarEventLabel {
  MILESTONES = 'Milestone',
  TASKS = 'Task',
  SHOWINGS = 'Showing',
  TOURS = 'Tour',
  CLOSINGS = 'Closing',
  PROJECT_KICKOFFS = 'Project Kickoff',
  EXPIRING_OFFERS = 'Offer Expiration',
  EXPIRING_LISTINGS = 'Listing Expiration',
  EXPIRING_PROJECTS = 'Project Deadline',
}

export const defaultCalendarTypeOptions = [
  'Task',
  'Milestone',
  'Showing',
  'Offer Expiration',
  'Tour',
  'Closing',
  'Listing Expiration',
  'Project Kickoff',
  'Project Deadline',
];

export const userTimezoneMap = {
  'US/Eastern': 'EST',
  'US/Central': 'CST',
  'US/Mountain': 'MST',
  'US/Pacific': 'PST',
  'US/Alaska': 'AKST',
  'US/Hawaii': 'HST',
};
